import { useRouteContext } from '@tanstack/react-router';
import { ngoAreaUrl } from './request-host';

/** A hook because the host comes from the request's own; pass the public path (`/login`), not `/ngos/login`. */
export function useNgoAreaUrl(): (path: string) => string {
	const { baseUrl } = useRouteContext({ from: '__root__' });
	return (path: string) => ngoAreaUrl(baseUrl, path);
}
